import { render, staticRenderFns } from "./VesselStatCounter.vue?vue&type=template&id=dabfae26&scoped=true"
import script from "./VesselStatCounter.vue?vue&type=script&lang=js"
export * from "./VesselStatCounter.vue?vue&type=script&lang=js"
import style0 from "./VesselStatCounter.vue?vue&type=style&index=0&id=dabfae26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabfae26",
  null
  
)

export default component.exports